// @ts-expect-error Lexxy does not have types
import { Extension } from "@37signals/lexxy"

// Opts every Lexxy toolbar button out of our title tooltips (see TitleTooltipController).
// Register it after the extensions that add toolbar buttons so that their buttons are covered too.
export default class DisableToolbarTooltipsExtension extends Extension {
  initializeToolbar(toolbar: HTMLElement) {
    toolbar.querySelectorAll("[title]").forEach((element) => element.setAttribute("data-disable-title-tooltip", "true"))
  }
}
